<template>
  <div>
    <NavBar v-if="notShouldShowNavBar" />
    <NavBarShop v-if="shouldShowNavBarShop" />

    <div class="content">
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </div>
    <StickyContactWidget />
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue';
import NavBarShop from './components/NavBarShop.vue';
import AppFooter from './components/FootBar.vue';
import StickyContactWidget from './components/StickyContactWidget.vue';

import { useHead } from '@vueuse/head'

export default {

  components: {
    NavBar,
    NavBarShop,
    AppFooter,
    StickyContactWidget
  },
  computed: {
    shouldShowFooter() {
      return this.$route.path.startsWith('/rent') || this.$route.path === '/price' || this.$route.path === '/contact' || this.$route.path.startsWith('/cart');
    },
    shouldShowNavBarShop() {
      return this.$route.path.startsWith('/rent') || this.$route.path === '/price' || this.$route.path.startsWith('/cart');
    },
    notShouldShowNavBar() {
      return !this.shouldShowNavBarShop;
    }
  },
  setup() {
    useHead({
      // Domyślny title i szablon dla podstron.
      title: 'Wypożyczalnia sprzętu barowego i obsługa eventów',
      titleTemplate: '%s | Cocktail Service',

      meta: [
        {
          name: 'description',
          content: 'Cocktail Service to ogólnopolska wypożyczalnia sprzętu barowego: bary mobilne, szkło, akcesoria i kompleksowa obsługa barmańska eventów.'
        },
        {
          name: 'keywords',
          content: 'wypożyczalnia sprzętu barowego, bary mobilne, obsługa barmańska, wynajem szkła, eventy, Warszawa'
        },
        { name: 'robots', content: 'index, follow, max-image-preview:large' },
        { name: 'author', content: 'Cocktail Service' },
        { property: 'og:type', content: 'website' },
        { property: 'og:site_name', content: 'Cocktail Service' },
        { property: 'og:locale', content: 'pl_PL' },
        { property: 'og:title', content: 'Cocktail Service - Wypożyczalnia sprzętu barowego i obsługa eventów' },
        {
          property: 'og:description',
          content: 'Wynajem barów mobilnych, szkła i akcesoriów barmańskich oraz profesjonalna obsługa eventów w Warszawie i całej Polsce.'
        },
        { property: 'og:url', content: 'https://www.cocktailservice.pl' + window.location.pathname },
        {
          property: 'og:image',
          content: 'https://www.cocktailservice.pl/img/Home-Page-1.webp'
        },
        { property: 'og:image:alt', content: 'Cocktail Service - profesjonalny bar mobilny na event' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: 'Cocktail Service - Wypożyczalnia sprzętu barowego i obsługa eventów' },
        {
          name: 'twitter:description',
          content: 'Wynajem barów mobilnych, szkła i akcesoriów barmańskich oraz profesjonalna obsługa eventów.'
        },
        { name: 'twitter:image', content: 'https://www.cocktailservice.pl/img/Home-Page-1.webp' }
      ],
      link: [
        {
          rel: 'canonical',
          href: 'https://www.cocktailservice.pl' + window.location.pathname
        }
      ]
    })
  }
};
</script>

<style>
body {
  margin: 0;
  transition: background-color 0.3s, color 0.3s;
}

.content {
  flex: 1;
}
</style>